import { Component, EventEmitter, inject, OnInit, Output } from '@angular/core';

import { LayerCategory } from 'app/modules/research/research.types';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Store } from '@ngxs/store';
import { ResearchState } from '../state/state';
import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';

@Component({
  selector: 'research-layers',
  templateUrl: './layers.component.html',
  styleUrls: ['./layers.component.scss'],
})
export class ResearchLayersComponent extends OnDestroyMixin implements OnInit {
  private readonly store = inject(Store);
  private readonly fb = inject(FormBuilder);

  constructor() {
    super();
  }

  @Output() selectedLayersChanged = new EventEmitter<string[]>();

  readonly staticLayersMeta = {
    heatmap: {
      icon: 'ts_layers-alt',
      description:
        // eslint-disable-next-line max-len
        'Choose one or more of the following options to display on the map. If you choose multiple options, we will combine them into a single ranking and color the map according that ranking.',
    },
    symbol: {
      icon: 'ts_location-pin-alt',
      description: 'Drop symbols in the map for the following data.',
    },
  };
  readonly layerCategories: LayerCategory[] = this.store.selectSnapshot(
    ResearchState.selectAvailableLayersGroupedByType,
  );
  readonly layersForm = this.fb.array([]) as FormArray<any>;

  activeOptionIndex = 0;

  get activeLayer() {
    return this.layerCategories[this.activeOptionIndex];
  }

  get activeLayerForm() {
    return this.layersForm.at(this.activeOptionIndex) as FormGroup<any> | FormControl<any>;
  }

  ngOnInit() {
    this.layerCategories.forEach((category) => {
      // currently only the 'symbol' category has multiple layers to be selected
      if (category.category !== 'symbol') {
        const selectedId = this.store.selectSnapshot(ResearchState.selectSelectedIdsFromCategory(category.category))[0];

        this.layersForm.push(this.fb.control(selectedId || null));
      } else {
        const selectedIds = this.store.selectSnapshot(ResearchState.selectSelectedIdsFromCategory(category.category));

        this.layersForm.push(
          this.fb.group({
            ...category.layers.reduce((acc, option) => {
              acc[option.id] = selectedIds.includes(option.id);
              return acc;
            }, {}),
          }),
        );
      }
    });

    this.layersForm.valueChanges.pipe(untilComponentDestroyed(this)).subscribe(
      (
        value: (
          | null
          | string
          | {
              [id: number]: boolean;
            }
        )[],
      ) => {
        let selectedLayersIds = [];

        value.forEach((v) => {
          if (v === null) return;

          if (typeof v === 'string') {
            selectedLayersIds.push(v);
          } else {
            selectedLayersIds = [...selectedLayersIds, ...Object.keys(v).filter((key) => v[key])];
          }
        });

        this.selectedLayersChanged.emit(selectedLayersIds);
      },
    );
  }
}
